import { useMemo } from 'react';
import { decodeJwtPayload } from '~/utils/decode-jwt';
import { getLocalStorageItem } from '~/utils/local-storage';

export function useSessionScopes(): Set<string> | null {
  const token = getLocalStorageItem<string>('access_token');

  return useMemo(() => {
    if (!token) return null;
    const payload = decodeJwtPayload(token);
    if (!payload) return null;
    const scopes = payload.scopes;
    if (!Array.isArray(scopes)) return null;
    const stringScopes = scopes.filter(
      (s): s is string => typeof s === 'string',
    );
    if (stringScopes.length === 0) return null;
    return new Set(stringScopes);
  }, [token]);
}
